import React from 'react';
import PropTypes from 'prop-types';

const SummaryComponent = ({ data = [] }) => {
  return (
    <div className="min-h-68.25">
      <div className="px-4 py-3 border-vamos-light-gray border-b">
        <p className="text-base font-bold">
          Summary
        </p>
      </div>
      <div className="px-4 py-3">
        <div className="px-8.5">
          <div className="w-73.5 grid gap-1">
            <div className="flex justify-between">
              <p className="text-vamos-gray">SITE VISITED</p>
              <p className="text-vamos-black">{data.sites_visited}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-vamos-gray">COUNTIES VISITED</p>
              <p className="text-vamos-black">{data.counties_visited}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-vamos-gray">H2A SITES VISITED</p>
              <p className="text-vamos-black">{data.h2a_sites_visited}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-vamos-gray">VISITS COMPLETED</p>
              <p className="text-vamos-black">{data.visits_completed}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-vamos-gray">NOTES CREATED</p>
              <p className="text-vamos-black">{data.notes_created}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-vamos-gray">TOTAL WORKERS REACHED</p>
              <p className="text-vamos-black">{data.total_workers_reached}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SummaryComponent.propTypes = {
  data: PropTypes.array,
};

export default SummaryComponent;
